/**
 * Novelune 品牌支付配置
 */
import type { BrandPaymentConfig } from '../types'
import { chapterCommonTexts, payCommonTexts, subscribeCommonTexts } from '../common'
import { colors as brandColors, theme as brandTheme } from '@/config/brands'

function hexToRgba(color: string, alpha: number) {
  if (!color.startsWith('#'))
    return color

  const hex = color.slice(1)
  const normalizedHex = hex.length === 3
    ? hex.split('').map(char => char + char).join('')
    : hex

  const red = Number.parseInt(normalizedHex.slice(0, 2), 16)
  const green = Number.parseInt(normalizedHex.slice(2, 4), 16)
  const blue = Number.parseInt(normalizedHex.slice(4, 6), 16)

  return `rgba(${red}, ${green}, ${blue}, ${alpha})`
}

const primaryGradientStart = '#FFBC7A'
const primaryGradientEnd = brandTheme.primaryColor
const primaryGradient = brandTheme.primaryGradient || `linear-gradient(90deg, ${primaryGradientStart} 0%, ${primaryGradientEnd} 100%)`
const paymentStickyBgStart = brandTheme.bgGlobal || '#FFF8F3'
const paymentStickyGradient = `linear-gradient(to top, ${paymentStickyBgStart} 0%, ${hexToRgba(paymentStickyBgStart, 0.88)} 50%, ${hexToRgba(paymentStickyBgStart, 0)} 100%)`

export const novelunePaymentConfig: BrandPaymentConfig = {
  brand: 'novelune',

  pay: {
    theme: {
      isLightPaymentSelector: true,
      paymentStickyGradient,
      colors: {
        tagGradient: 'linear-gradient(132deg, #F961BC 0%, #F74984 100%)',
      },
    },
    texts: payCommonTexts,
    resources: {
      goldCoinIcon: '/images/novelune/welfare-gold.png',
    },
  },

  subscribe: {
    texts: subscribeCommonTexts,
    darkPaymentSelector: false,
    resources: {
      vipBg: '/images/novelune/vip_bg.webp',
      memberSubscribeBg: '/images/novelune/member_subscribe_bg.webp',
      vipIcon: '/images/novelune/vip_icon2.png',
      vipDiscountIcon: '/images/novelune/vip_discount.png',
      discountBg: '/images/novelune/discount.avif',
      showVipIcon: true,
    },
    colors: {
      redGradient: primaryGradient,
      purpleTextGradient: 'linear-gradient(180deg, #FFA876 0%, #FF8A4C 100%)',
      subscribeText1: brandColors!.primary,
      subscribeText2: brandColors!.text.primary,
      subscribeText3: brandColors!.text.secondary,
      subscribeText4: brandColors!.text.secondary,
      subscribeCardBg: 'linear-gradient(90deg, #FFFFFF 0%, #FFF5EE 100%)',
      cycleTextGradient: 'linear-gradient(180deg, #FFD4B8 0%, #FFA876 100%)',
      badgeGradient: 'linear-gradient(132deg, #FFC49A 0%, #FF8A4C 100%)',
    },
  },

  chapter: {
    texts: chapterCommonTexts,
    darkPaymentSelector: false,
    themeDefaults: {
      background: '#FFFFFF',
      size: '38',
    },
    colors: {
      coinsGradient: `linear-gradient(180deg, ${brandColors!.primary}, ${brandColors!.bg.global})`,
      coinsPopupText1: brandColors!.text.inverse,
      coinsPopupText2: primaryGradientStart,
      coinsPopupText3: brandColors!.text.secondary,
      coinsPopupText4: brandColors!.text.inverse,
      vipBg: brandColors!.bg.card,
      subscribeActiveBg: brandColors!.bg.card,
      purpleTextGradient: 'linear-gradient(180deg, #FF8A4C 0%, #FFBC7A 70%, #FFF5EE 100%)',
      pinkGradient: 'linear-gradient(132deg, #F961BC 0%, #F74984 100%)',
      subscribeCardBg: 'linear-gradient(90deg, #FFFFFF 0%, #FFF5EE 100%)',
      purchaseActiveBg: '#FFF2EC',
      memberSubscribeBg: '/images/novelune/chapter/member_subscribe_bg.webp',
      showVipIcon: true,
    },
  },
}
